var _mask, _path, _path2, _mask2, _path3, _path4, _mask3, _path5, _path6, _mask4, _path7, _path8, _mask5, _path9, _path10, _mask6, _path11, _path12, _mask7, _path13, _path14, _mask8, _path15, _path16, _mask9, _path17, _path18, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanningEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 96,
    viewBox: "0 0 336 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3420_50197",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H112V32H0V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H112V32H0V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-1H-1V0H0ZM0 32H-1V33H0V32ZM0 1H112V-1H0V1ZM112 31H0V33H112V31ZM1 32V0H-1V32H1Z",
    fill: "#D9D9D9",
    mask: "url(#path-1-inside-1_3420_50197)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_3420_50197",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112 0H224V32H112V0Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112 0H224V32H112V0Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112 0V-1H111V0H112ZM112 32H111V33H112V32ZM112 1H224V-1H112V1ZM224 31H112V33H224V31ZM113 32V0H111V32H113Z",
    fill: "#D9D9D9",
    mask: "url(#path-3-inside-2_3420_50197)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_3420_50197",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224 0H336V32H224V0Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M224 0H336V32H224V0Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M224 0V-1H223V0H224ZM336 0H337V-1H336V0ZM336 32V33H337V32H336ZM224 32H223V33H224V32ZM224 1H336V-1H224V1ZM335 0V32H337V0H335ZM336 31H224V33H336V31ZM225 32V0H223V32H225Z",
    fill: "#D9D9D9",
    mask: "url(#path-5-inside-3_3420_50197)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-4_3420_50197",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 32H112V64H0V32Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32H112V64H0V32Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 64H-1V65H0V64ZM112 63H0V65H112V63ZM1 64V32H-1V64H1Z",
    fill: "#D9D9D9",
    mask: "url(#path-7-inside-4_3420_50197)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-5_3420_50197",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112 32H224V64H112V32Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112 32H224V64H112V32Z",
    fill: "#3582FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M112 64H111V65H112V64ZM224 63H112V65H224V63ZM113 64V32H111V64H113Z",
    fill: "#D9D9D9",
    mask: "url(#path-9-inside-5_3420_50197)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-6_3420_50197",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224 32H336V64H224V32Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M224 32H336V64H224V32Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M336 64V65H337V64H336ZM224 64H223V65H224V64ZM335 32V64H337V32H335ZM336 63H224V65H336V63ZM225 64V32H223V64H225Z",
    fill: "#D9D9D9",
    mask: "url(#path-11-inside-6_3420_50197)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-7_3420_50197",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 64H112V96H0V64Z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 64H112V96H0V64Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 96H-1V97H0V96ZM112 95H0V97H112V95ZM1 96V64H-1V96H1Z",
    fill: "#D9D9D9",
    mask: "url(#path-13-inside-7_3420_50197)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-8_3420_50197",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112 64H224V96H112V64Z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M112 64H224V96H112V64Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M112 96H111V97H112V96ZM224 95H112V97H224V95ZM113 96V64H111V96H113Z",
    fill: "#D9D9D9",
    mask: "url(#path-15-inside-8_3420_50197)"
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-9_3420_50197",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224 64H336V96H224V64Z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M224 64H336V96H224V64Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M336 96V97H337V96H336ZM224 96H223V97H224V96ZM335 64V96H337V64H335ZM336 95H224V97H336V95ZM225 96V64H223V96H225Z",
    fill: "#D9D9D9",
    mask: "url(#path-17-inside-9_3420_50197)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3420_50197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.27 68.28C195.99 67.92 195.64 67.19 195.03 66.28C194.68 65.78 193.82 64.83 193.56 64.34C193.372 64.0423 193.318 63.6797 193.41 63.34C193.567 62.6943 194.179 62.2659 194.84 62.34C195.351 62.4427 195.82 62.693 196.19 63.06C196.448 63.3032 196.686 63.5675 196.9 63.85C197.06 64.05 197.1 64.13 197.28 64.36C197.46 64.59 197.58 64.82 197.49 64.48C197.42 63.98 197.3 63.14 197.13 62.39C197 61.82 196.97 61.73 196.85 61.3C196.73 60.87 196.66 60.51 196.53 60.02C196.411 59.5386 196.318 59.0513 196.25 58.56C196.124 57.9318 196.216 57.2793 196.51 56.71C196.859 56.3814 197.372 56.2947 197.81 56.49C198.25 56.8154 198.579 57.2697 198.75 57.79C199.012 58.4304 199.187 59.1031 199.27 59.79C199.43 60.79 199.74 62.25 199.75 62.55C199.75 62.18 199.68 61.4 199.75 61.05C199.819 60.6852 200.073 60.3824 200.42 60.25C200.718 60.1587 201.033 60.1381 201.34 60.19C201.65 60.2549 201.925 60.4332 202.11 60.69C202.342 61.2734 202.47 61.8926 202.49 62.52C202.517 61.9706 202.611 61.4266 202.77 60.9C202.937 60.6646 203.181 60.4948 203.46 60.42C203.79 60.3596 204.129 60.3596 204.46 60.42C204.731 60.5107 204.968 60.6816 205.14 60.91C205.352 61.4404 205.48 62.0004 205.52 62.57C205.52 62.71 205.59 62.18 205.81 61.83C205.924 61.4906 206.211 61.238 206.562 61.1673C206.913 61.0966 207.275 61.2186 207.512 61.4873C207.749 61.756 207.824 62.1306 207.71 62.47C207.71 63.12 207.71 63.09 207.71 63.53C207.71 63.97 207.71 64.36 207.71 64.73C207.673 65.3152 207.593 65.8969 207.47 66.47C207.296 66.9772 207.054 67.4582 206.75 67.9C206.264 68.44 205.863 69.0502 205.56 69.71C205.485 70.0379 205.451 70.3738 205.46 70.71C205.459 71.0207 205.499 71.3301 205.58 71.63C205.171 71.6733 204.759 71.6733 204.35 71.63C203.96 71.57 203.48 70.79 203.35 70.55C203.286 70.4212 203.154 70.3398 203.01 70.3398C202.866 70.3398 202.734 70.4212 202.67 70.55C202.45 70.93 201.96 71.62 201.62 71.66C200.95 71.74 199.57 71.66 198.48 71.66C198.48 71.66 198.66 70.66 198.25 70.3C197.84 69.9401 197.42 69.52 197.11 69.24L196.27 68.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.27 68.28C195.99 67.92 195.64 67.19 195.03 66.28C194.68 65.78 193.82 64.83 193.56 64.34C193.372 64.0423 193.318 63.6797 193.41 63.34C193.567 62.6943 194.179 62.2659 194.84 62.34C195.351 62.4427 195.82 62.693 196.19 63.06C196.448 63.3032 196.686 63.5675 196.9 63.85C197.06 64.05 197.1 64.13 197.28 64.36C197.46 64.59 197.58 64.82 197.49 64.48C197.42 63.98 197.3 63.14 197.13 62.39C197 61.82 196.97 61.73 196.85 61.3C196.73 60.87 196.66 60.51 196.53 60.02C196.411 59.5386 196.318 59.0513 196.25 58.56C196.124 57.9318 196.216 57.2793 196.51 56.71C196.859 56.3814 197.372 56.2947 197.81 56.49C198.25 56.8154 198.579 57.2697 198.75 57.79C199.012 58.4304 199.187 59.1031 199.27 59.79C199.43 60.79 199.74 62.25 199.75 62.55C199.75 62.18 199.68 61.4 199.75 61.05C199.819 60.6852 200.073 60.3824 200.42 60.25C200.718 60.1587 201.033 60.1381 201.34 60.19C201.65 60.2549 201.925 60.4332 202.11 60.69C202.342 61.2734 202.47 61.8926 202.49 62.52C202.517 61.9706 202.611 61.4266 202.77 60.9C202.937 60.6646 203.181 60.4948 203.46 60.42C203.79 60.3596 204.129 60.3596 204.46 60.42C204.731 60.5107 204.968 60.6816 205.14 60.91C205.352 61.4404 205.48 62.0004 205.52 62.57C205.52 62.71 205.59 62.18 205.81 61.83C205.924 61.4906 206.211 61.238 206.562 61.1673C206.913 61.0966 207.275 61.2186 207.512 61.4873C207.749 61.756 207.824 62.1306 207.71 62.47C207.71 63.12 207.71 63.09 207.71 63.53C207.71 63.97 207.71 64.36 207.71 64.73C207.673 65.3152 207.593 65.8969 207.47 66.47C207.296 66.9772 207.054 67.4582 206.75 67.9C206.264 68.44 205.863 69.0502 205.56 69.71C205.485 70.0379 205.451 70.3738 205.46 70.71C205.459 71.0207 205.499 71.3301 205.58 71.63C205.171 71.6733 204.759 71.6733 204.35 71.63C203.96 71.57 203.48 70.79 203.35 70.55C203.286 70.4212 203.154 70.3398 203.01 70.3398C202.866 70.3398 202.734 70.4212 202.67 70.55C202.45 70.93 201.96 71.62 201.62 71.66C200.95 71.74 199.57 71.66 198.48 71.66C198.48 71.66 198.66 70.66 198.25 70.3C197.84 69.94 197.42 69.52 197.11 69.24L196.27 68.28Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.75 68.8259V65.3741C204.75 65.1675 204.582 65 204.375 65C204.168 65 204 65.1675 204 65.3741V68.8259C204 69.0325 204.168 69.2 204.375 69.2C204.582 69.2 204.75 69.0325 204.75 68.8259Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.77 68.8246L202.75 65.3711C202.749 65.1649 202.58 64.9988 202.373 65C202.166 65.0012 201.999 65.1693 202 65.3754L202.02 68.8289C202.021 69.035 202.19 69.2012 202.397 69.2C202.604 69.1988 202.771 69.0307 202.77 68.8246Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 65.379L200.02 68.8254C200.021 69.0335 200.19 69.2012 200.397 69.2C200.604 69.1988 200.771 69.0291 200.77 68.821L200.75 65.3746C200.749 65.1665 200.58 64.9988 200.373 65C200.166 65.0012 199.999 65.1709 200 65.379Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3420_50197",
    x: 186.2,
    y: 51.2,
    width: 27.6,
    height: 27.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3420_50197"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3420_50197",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanningEmptyState);
export default __webpack_public_path__ + "static/media/planning-empty-state.0133817fe8a4793147bfc21bb0c51f20.svg";
export { ForwardRef as ReactComponent };